module.exports = __webpack_public_path__ + "img/Frame_37.b6b1baf7.png";